import { AsyncGridColumns } from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.event',
    field: 'eventTitle',
    sortable: false,
    width: 180,
  },
  {
    headerName: 'column.user',
    field: 'user',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.date',
    field: 'date',
    sortable: false,
    flex: 1,
  },
]
